import r from "../../shared-lib/braze-shared-lib.js";
export default class u {
  constructor() {
    this.Se = {};
  }
  ut(t) {
    if ("function" != typeof t) return null;
    const i = r.it.nt();
    return (this.Se[i] = t), i;
  }
  removeSubscription(t) {
    delete this.Se[t];
  }
  removeAllSubscriptions() {
    this.Se = {};
  }
  bu() {
    return Object.keys(this.Se).length;
  }
  St(t) {
    const i = [];
    for (let r in this.Se) i.push(this.Se[r](t));
    return i;
  }
}
